import { createStore } from 'satcheljs';
import { TxpSettingsDialogViewState } from './viewSchema/TxpSettingsDialogViewState';
import TxpSettingsDialogViewStates from './viewSchema/TxpSettingsDialogViewStates';

export interface TxpSettingsViewStateStore {
    txpSettingsDialogViewState: TxpSettingsDialogViewState;
    txpSettingsErrorDialogViewState: TxpSettingsDialogViewStates;
}

const initialTxpSettingsViewStateStore: TxpSettingsViewStateStore = {
    txpSettingsDialogViewState: {
        viewState: TxpSettingsDialogViewStates.Hidden,
        txpSettings: {
            CreateEventsFromEmailAsPrivate: undefined,
            EntityTypeProcessorLevelSettings: {
                FlightReservation: undefined,
                FoodEstablishmentReservation: undefined,
                LodgingReservation: undefined,
                RentalCarReservation: undefined,
                ParcelDelivery: undefined,
                EventReservation: undefined,
                Invoice: undefined,
                ServiceReservation: undefined,
            },
        },
    },
    txpSettingsErrorDialogViewState: TxpSettingsDialogViewStates.Hidden,
};

const getStore = createStore<TxpSettingsViewStateStore>(
    'txpSettingsViewState',
    initialTxpSettingsViewStateStore
);
export default getStore;
